import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { PdfQuestionnaireEvaluation } from "Components/PdfQuestionnaire/PdfQuestionnaireEvaluation";
import { PdfTemplatePage } from "Components/PdfTemplate/PdfTemplatePage";
import { useParams } from "react-router-dom";

export const PdfTemplateQuestionnaireEvaluationPage = () => {
  const { analysisId, versionId } = useParams() as {
    analysisId: string;
    versionId: string;
  };

  return (
    <AnalysisDetailContext.Provider value={{ analysisId, versionId, readOnly: true, canAddFamilyMember: false }}>
      <PdfTemplatePage>
        <PdfQuestionnaireEvaluation />
      </PdfTemplatePage>
    </AnalysisDetailContext.Provider>
  );
};
